/**
 * The shared CSV export utility -- generalized from the Stocks page's
 * original export so every table in the app downloads the same way.
 * Real xlsx export (exportXlsx.ts, SheetJS) is kept where it already
 * exists; this covers the common case every table needs.
 */
export function exportRowsAsCsv(
  rows: Record<string, unknown>[],
  columns: { key: string; label: string }[],
  filename: string,
) {
  const header = columns.map((c) => c.label).join(",");
  const lines = rows.map((r) =>
    columns
      .map((c) => {
        const v = r[c.key];
        const s = v === null || v === undefined ? "" : typeof v === "object" ? JSON.stringify(v) : String(v);
        return s.includes(",") || s.includes('"') || s.includes("\n") ? `"${s.replace(/"/g, '""')}"` : s;
      })
      .join(","),
  );
  const csv = [header, ...lines].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
